module.exports = "images/doc-country-menu.5eee2362ab618a57fbb1ccff625fbfee.png";